import type { TooltipOptions } from 'chart.js';
import {
  chartFontFamily,
  chartGridColor,
  chartLabelColor,
  chartTextColor,
  chartTooltipBackground,
  chartTooltipBorder,
} from './chartTheme';
import { registerPortalCharts } from './registerCharts';

registerPortalCharts();

export function formatChartTick(value: string | number): string {
  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric)) {
    return '';
  }

  return numeric.toLocaleString('pt-BR');
}

export function portalTooltipOptions(): Partial<TooltipOptions> {
  return {
    backgroundColor: chartTooltipBackground(),
    titleColor: chartLabelColor(),
    bodyColor: chartTextColor(),
    borderColor: chartTooltipBorder(),
    borderWidth: 1,
    padding: 10,
    cornerRadius: 8,
    titleFont: { family: chartFontFamily(), size: 12, weight: 600 },
    bodyFont: { family: chartFontFamily(), size: 12 },
  };
}

export function categoryTickFont(size = 12) {
  return {
    color: chartTextColor(),
    font: { family: chartFontFamily(), size },
  };
}

export function valueGrid() {
  return {
    color: chartGridColor(),
  };
}

export function hiddenAxisBorder() {
  return { display: false as const };
}

export function legendOptions(display: boolean) {
  return {
    display,
    position: 'bottom' as const,
    labels: {
      color: chartLabelColor(),
      font: { family: chartFontFamily(), size: 12 },
      usePointStyle: true,
      pointStyle: 'circle' as const,
      boxWidth: 8,
      padding: 14,
    },
  };
}

export function measureTextWidth(text: string, font: string): number {
  if (typeof document === 'undefined' || text === '') {
    return 0;
  }

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    return text.length * 7;
  }

  context.font = font;
  return context.measureText(text).width;
}
